export default __webpack_public_path__ + "static/gem-card-art-10b717e924951b66564258293e603e4d.png";